<template>
  <dl class="contract-details">
    <dt v-if="showAllDetails">
      {{ i18n.t('/FleetContracts/Details/CompanyName') }}
    </dt>
    <dd v-if="showAllDetails">{{ company.BusinessName || '-' }}</dd>

    <dt v-if="showAllDetails">
      {{ i18n.t('/FleetContracts/Details/CustomerId') }}
    </dt>
    <dd v-if="showAllDetails">{{ company.CustomerId || '-' }}</dd>

    <dt v-if="showAllDetails">
      {{ i18n.t('/FleetContracts/Details/CompanyAddress') }}
    </dt>
    <dd v-if="showAllDetails">{{ companyAddress || '-' }}</dd>

    <dt v-if="showAllDetails">
      {{ i18n.t('/FleetContracts/Details/CompanyPostalCodeCity') }}
    </dt>
    <dd v-if="showAllDetails">{{ company.ZipCode || '-' }} {{ company.City }}</dd>

    <dt v-if="showAllDetails">
      {{ i18n.t('/FleetContracts/Details/CompanyPhone') }}
    </dt>
    <dd v-if="showAllDetails">{{ company.Phone || '-' }}</dd>

    <dt v-if="showAllDetails">
      {{ i18n.t('/FleetContracts/Details/ContractNumber') }}
    </dt>
    <dd v-if="showAllDetails">
      <a :href="linkToDap" target="_blank" alt="DAP">{{ contract.ContractNumber || '-' }}</a>
    </dd>

    <dt>{{ i18n.t('/FleetContracts/Details/KindOfDeal') }}</dt>
    <dd>{{ contract.KindOfDeal || '-' }}</dd>

    <dt>{{ i18n.t('/FleetContracts/Details/DiscountStructure') }}</dt>
    <dd>{{ contract.DiscountStructure || '-' }}</dd>

    <dt>{{ i18n.t('/FleetContracts/Details/CustomerRebateSettlement') }}</dt>
    <dd>{{ contract.CustomerRebateSettlement || '-' }}</dd>

    <dt>{{ i18n.t('/FleetContracts/Details/DiscountPercentage') }}</dt>
    <dd>{{ contract.DiscountPercentage || '-' }}</dd>

    <dt>{{ i18n.t('/FleetContracts/Details/FinalAscriptionDate') }}</dt>
    <dd>{{ contract.FinalAscriptionDate || '-' }}</dd>

    <dt>{{ i18n.t('/FleetContracts/Details/MandatoryAccessories') }}</dt>
    <dd>{{ contract.MandatoryOptions || '-' }}</dd>

    <dt v-if="showAllDetails">
      {{ i18n.t('/FleetContracts/Details/MatchPercentageLabel') }}
    </dt>
    <dd v-if="showAllDetails">
      <match-percentage :percentage="contract.MatchPercentage" />
    </dd>

    <dt>{{ i18n.t('/FleetContracts/Details/Remarks') }}</dt>
    <dd class="allow-linebreaks">{{ contract.Remarks }}</dd>
  </dl>
</template>

<script>
import MatchPercentage from '@/components/generic/presentational/atoms/matchPercentage/MatchPercentage.vue'

export default {
  components: {
    MatchPercentage,
  },
  props: {
    contract: {
      type: Object,
      default: null,
    },
    showAllDetails: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    company() {
      return this.contract.CustomerFleetCompany
    },
    companyAddress() {
      return `${this.company.Street} ${this.company.Housenumber}`
    },
    linkToDap() {
      return `${window.VUE_CLI_EXPORTS.settings.DapUrl}${this.contract.ContractNumber}`
    },
  },
}
</script>

<style lang="scss" scoped>
h5 {
  display: inline-block;
}

.contract-details {
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin-bottom: 1em;
  column-gap: 6px;

  .allow-linebreaks {
    white-space: break-spaces;
  }
}
</style>
